<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.key" :style="isMobile ? 'width: 230px !important;' : ''" placeholder="医院名称/任职机构"></el-input>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <!-- <el-button size="mini" type="danger" icon="el-icon-edit" @click="batchApprove">批量驳回</el-button> -->
        <!-- <div style="margin-bottom: 10px"></div> -->
        <el-table
          border
          :max-height="tableHeight"
          :data="tabel_list"
          header-cell-class-name="header_cell_name"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column label="操作" width="90">
            <template scope="scope">
              <el-link type="primary" @click="handleOpen(scope.row)">
                <i class="el-icon-edit"></i>
                审批
              </el-link>
            </template>
          </el-table-column>

          <el-table-column prop="hcoName" label="医院名称" width="180"></el-table-column>
          <el-table-column prop="approvalMaster.approvalName" label="审批类型" width="230"></el-table-column>
          <el-table-column prop="approvaList[0].approverName" label="申请人" width></el-table-column>
          <el-table-column prop="approvalMaster.createTime" label="申请日期" width="180"></el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="batchApprove">批量同意</el-button>
          <el-pagination
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right; vertical-align: middle; margin-top: 3px"
          ></el-pagination>
        </el-col>
      </div>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import { cataractnnvmp_approvalspending, cataractnnvmp_batchapprovalclaim } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    async batchApprove() {
      if (this.sels.length == 0) {
        this.$message({
          message: '请选择要审批的数据',
          type: 'warning',
        })
        return
      }
      this.$confirm('确认批量审批吗？', '提示', {}).then(async () => {
        let list = []
        for (var i in this.sels) {
          list.push({
            approvedId: this.sels[i].approvalMaster.id,
            isApproved: true,
            reasonMessage: '',
          })
        }
        const { data } = await cataractnnvmp_batchapprovalclaim(list)
        if (data.code == 200) {
          this.$message({
            message: data.msg,
            type: 'success',
          })
          this.getModules_search()
        } else {
          this.$message({
            message: data.msg,
            type: 'error',
          })
        }
      })
    },
    //编辑
    handleOpen: function (e, type) {
      // JSON.parse(JSON.stringify(e));
      this.$router.push({
        path: '/NVBP/cataractnnvmpSP',
        query: {
          id: e.ID,
          status: 'SP',
          back_url: '/NVBP/no_approve',
          hco_list: JSON.stringify(e),
        },
      })
    },
    save(res) {
      console.log(res)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(row, column, rowIndex, columnIndex)
      if (columnIndex === 7 || columnIndex === 8) {
        if (rowIndex % 16 === 0) {
          return {
            rowspan: 16,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    // 合并数据
    mergeData(data) {
      //   let spanArr = []
      //   let concatSpanArr = []
      let merge = {}
      data.map((item, index) => {
        merge = {
          all_potential: item.potential,
          drp: item.drp,
          drg: item.drg,
        }
        item.details.map((item2, index2) => {
          item2 = { ...item2, ...merge }
          item.details[index2] = item2
          //   item2.ingdex = 'ssss'
          console.log(item2)
        })
      })
      return data
      //   console.log(data)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      console.log(para)
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      cataractnnvmp_approvalspending(para).then((res) => {
        this.total = res.data.data.dataCount
        this.tabel_list = res.data.data.data
        console.log(this.tabel_list)
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 190
        } else {
          this.tableHeight = window.innerHeight - 250
        }
      })
    })
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped></style>
